import React from 'react';
import { bool, func } from 'prop-types';

import { Button, Container, Row, Col, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const PopUpAutoTnc = (props) => {
  const { show, onHide } = props;

  return (
    <PopUpCenterV2
      size="lg"
      title="Disclaimer"
      show={show}
      onHide={onHide}
      data-testid="popup-autoTnc"
    >
      <Container padding="8px 0px 24px" data-testid="div-tncContent">
        <Typography type="body" bold align="left" margin="8px 0 16px">
          Dengan menekan tombol setuju berarti saya telah mengerti dan menyetujui bahwa:
        </Typography>
        <Typography as="span" type="body" align="left">
          <ul>
            <li>
              Auto Trading akan melakukan pengecekan harga pada saat pembukaan market, yaitu pada
              pukul 09:00:00 WIB.
            </li>
            <li>
              Eksekusi Auto Trading bergantung pada antrian di bursa, karena itu ada kemungkinan
              terjadi jeda waktu.
            </li>
            <li>
              Proses pembentukan harga pada saat sesi pembukaan dapat mempengaruhi eksekusi Auto
              Trading.
            </li>
            <li>
              Kondisi Auto Trading terpenuhi jika harga dan kondisi yang saya tentukan sudah sesuai
              dengan harga saat ini.
            </li>
            <li>
              Kondisi beli akan terpenuhi jika Buying Power cukup dan kondisi jual akan terpenuhi
              jika jumlah lot yang dimiliki cukup.
            </li>
            <li>Maksimal Auto Order yang dibuat adalah 30 (tiga puluh) Auto Order.</li>
            <li>Maksimal periode tiap Auto Order adalah 90 hari.</li>
            <li>Mengaktifkan Auto Trading adalah sepenuhnya tanggung jawab pengguna.</li>
            <li>Ajaib tidak menanggung kesalahan atau kekurangan pada fitur Auto Trading.</li>
          </ul>
        </Typography>
      </Container>
      <Row noGutters align="center">
        <Col size="auto">
          <Button variant="primary" size="lg" onClick={onHide}>
            Mengerti
          </Button>
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpAutoTnc.propTypes = {
  show: bool,
  onHide: func,
};

PopUpAutoTnc.defaultProps = {
  show: false,
  onHide: () => {},
};

export default PopUpAutoTnc;
